import { Colors, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';

const noProjectsMessageStyles = {
  width: '100%',
  justifyContent: 'center',
};

const NoProjectsMessage = () => (
  <FlexRow sx={noProjectsMessageStyles}>
    <Text.Lead color={Colors.TextQuiet}>No projects found for this company</Text.Lead>
  </FlexRow>
);

export default NoProjectsMessage;
